import React, { useContext, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { connect, RootStateOrAny } from 'react-redux';
import { SplitProvider } from 'react-splitio';

import { makeSplitConfigObject } from 'services/features/utils';
import { checkUserAuth, CHECK_USER_AUTH } from 'services/user/actions';
import { isUserAuthorized, userEmail } from 'services/user/getters';
import { useQuery } from '@redux-requests/react';
import { LoginBox } from 'shared/components/Login';
import { ToggleFeature, flags, treatments } from 'services/features';

// Bindings
const StyledLoginBoxContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

type AuthenticationWrapperProps = {
    isUserAuthorized: boolean;
    checkUserAuth: Function;
    children: any;
    userEmail?: string;
};


const AuthenticationWrapper = (props: AuthenticationWrapperProps) => {
    const { isUserAuthorized, userEmail, children } = props;
    const { loading = true } = useQuery({ type: CHECK_USER_AUTH });

    useEffect(() => {
        props.checkUserAuth();
    }, []);

    //  ----Template----
    return isUserAuthorized && userEmail ? (
        <SplitProvider config={makeSplitConfigObject(userEmail)}>
            <ToggleFeature feature={flags.WF_APP_ENABLED} match={treatments.ON}>
                {children}
            </ToggleFeature>

        </SplitProvider>
    ) : (
        <StyledLoginBoxContainer>
            <LoginBox loading={loading} />
        </StyledLoginBoxContainer>
    );
}


const mapStateToProps = (state: RootStateOrAny) => ({
    isUserAuthorized: isUserAuthorized(state),
    userEmail: userEmail(state),
});

const dispatchProps = {
    checkUserAuth,
};

export default connect(mapStateToProps, dispatchProps)(AuthenticationWrapper);

export { AuthenticationWrapper };
